module.exports = __webpack_public_path__ + "static/media/f378e5c9d61745250f18c44f30a8c10.f147290b.jpg";